import { Col, NavLink, Row } from "reactstrap";
import maelano from "../../../../assets/images/logo/MAELANO.svg";
import logo from "../../../../assets/images/logo/logo.svg";
import apple from "../../../../assets/images/logo/apple.svg";
import playstore from "../../../../assets/images/logo/playstore.svg";
import facebook from "../../../../assets/images/social/facebook.svg";
import instagram from "../../../../assets/images/social/instagram.svg";
import twitter from "../../../../assets/images/social/twitter.svg";
import pinterest from "../../../../assets/images/social/pinterest.svg";
import linkedin from "../../../../assets/images/social/linkedin.svg";

import paypal from "../../../../assets/images/payment/paypal.svg";
import visa from "../../../../assets/images/payment/visa.svg";
import gpay from "../../../../assets/images/payment/g-pay.svg";
import express from "../../../../assets/images/payment/am-express.svg";
import master from "../../../../assets/images/payment/master-card.svg";
import applepay from "../../../../assets/images/payment/apple-pay.svg";
import styles from "./LoginFooter.module.scss";
import { useState } from "react";

const LoginFooter = () => {
    const [expandItemIndex, setExpandItemIndex] = useState(null);

    const handleClick = (index) => {
        if (expandItemIndex === index) {
            setExpandItemIndex(null);
            return;
        }

        setExpandItemIndex(index);
    };

    return (
        <footer>
            <div className={styles["footer-wrapper"]}>
                <Row className='row-gap-3'>
                    <Col xs={12} md={12} lg={12} xl='2'>
                        <div className="text-center">
                            <NavLink href="/landingpage" target="_blank">
                                <div className="mb-3">
                                    <div className="bg-white p-3 rounded-3 d-inline-block">
                                        <img src={logo} alt="Logo" />
                                    </div>
                                </div>
                                <div className="d-inline-block">
                                    <img src={maelano} alt="Maelano" />
                                </div>
                            </NavLink>
                        </div>
                    </Col>

                    <Col xs={12} md="auto" lg='auto' xl='2'>
                        <div className='text-center text-md-start'>
                            <div className="fs-5 fw-medium mb-2 mb-md-3" onClick={() => handleClick(0)}>Maelano</div>
                            <ul className={`${styles['ul']} mb-0 list-unstyled d-md-block d-${expandItemIndex === 0 ? 'block' : 'none'}`}>
                                <li><NavLink href="/about-us" target="_blank">About Us</NavLink></li>
                                <li><NavLink href="#" target="_blank">Blogs</NavLink></li>
                                <li><NavLink href="/contact-us" target="_blank">Contact us</NavLink></li>
                                <li><NavLink href="#" target="_blank">Affiliate Program</NavLink></li>
                                <li><NavLink href="/startselling" target="_blank">Start Selling</NavLink></li>
                                <li><NavLink href="#" target="_blank">Partnerships</NavLink></li>
                                <li><NavLink href="/testimonials" target="_blank">Testimonials</NavLink></li>
                                <li><NavLink href="#" target="_blank">Careers</NavLink></li>
                            </ul>
                        </div>
                    </Col>

                    <Col xs={12} md="auto" lg='auto' xl='2'>
                        <div className='text-center text-md-start'>
                            <div className="fs-5 fw-medium mb-2 mb-md-3" onClick={() => handleClick(1)}>Customer Service</div>
                            <ul className={`${styles['ul']} mb-0 list-unstyled d-md-block d-${expandItemIndex === 1 ? 'block' : 'none'}`}>
                                <li><NavLink href="/customer-services" target="_blank">FAQ’s</NavLink></li>
                                <li><NavLink href="/contact-us" target="_blank">Contact us</NavLink></li>
                                <li><NavLink href="#" target="_blank">Purchase protection</NavLink></li>
                                <li><NavLink href="#" target="_blank">Cookie policy</NavLink></li>
                                <li><NavLink href="#" target="_blank">Privacy policy</NavLink></li>
                                <li><NavLink href="#" target="_blank">Terms and Conditions</NavLink></li>
                                <li><NavLink href="#" target="_blank">Return Policy</NavLink></li>
                            </ul>
                        </div>
                    </Col>

                    <Col xs={12} md="auto" lg='auto' xl='2'>
                        <div className='text-center text-md-start'>
                            <div className="fs-5 fw-medium mb-2 mb-md-3" onClick={() => handleClick(2)}>Seller Services</div>
                            <ul className={`${styles['ul']} mb-0 list-unstyled d-md-block d-${expandItemIndex === 2 ? 'block' : 'none'}`}>
                                <li><NavLink href="/sellerterms" target="_blank">Seller Terms and Policies</NavLink></li>
                                <li><NavLink href="/sellertraining" target="_blank">Training and Resources</NavLink></li>
                                <li><NavLink href="/sellersupport" target="_blank">Customer Services and Support</NavLink></li>
                                <li><NavLink href="/sellercontactus" target="_blank">Contact and Support</NavLink></li>
                                <li><NavLink href="/sellercontactus#seller-faqs" target="_blank">FAQ’s for Seller</NavLink></li>
                                <li><NavLink href="/sellerregistration" target="_blank">Seller Registration Form</NavLink></li>
                            </ul>
                        </div>
                    </Col>

                    <Col xs={12} md="auto" lg='auto' xl='2'>
                        <div className='text-center text-md-start'>
                            <div className="fs-5 fw-medium mb-2 mb-md-3" onClick={() => handleClick(3)}>Affiliate Services</div>
                            <ul className={`${styles['ul']} mb-0 list-unstyled d-md-block d-${expandItemIndex === 3 ? 'block' : 'none'}`}>
                                <li><NavLink href="#" target="_blank">Affiliate registration form</NavLink></li>
                                <li><NavLink href="#" target="_blank">Terms and Conditions</NavLink></li>
                                <li><NavLink href="#" target="_blank">FAQ’s for Affiliates</NavLink></li>
                                <li><NavLink href="#" target="_blank">Training and Resources</NavLink></li>
                                <li><NavLink href="#" target="_blank">Affiliate Agreement</NavLink></li>
                                <li><NavLink href="#" target="_blank">Contact and Support</NavLink></li>
                            </ul>
                        </div>
                    </Col>

                    <Col xs={12} md="auto" lg='auto' xl='2'>
                        <div className='text-center text-md-start'>
                            <div className="fs-5 fw-medium mb-2 mb-md-3" onClick={() => handleClick(4)}>Download App</div>
                            <ul className={`${styles['ul']} mb-0 list-unstyled d-md-block d-${expandItemIndex === 4 ? 'block' : 'none'}`}>
                                <li><NavLink href="#" target="_blank">Exclusive offers</NavLink></li>
                                <li><NavLink href="#" target="_blank">Track order anytime</NavLink></li>
                                <li><NavLink href="#" target="_blank">Instant checkout</NavLink></li>
                                <li><NavLink href="#" target="_blank">Offers and coupons alerts</NavLink></li>
                                <li><NavLink href="#" target="_blank">Price-drop alerts</NavLink></li>
                            </ul>

                            <div className="mt-3 d-flex flex-column align-items-center align-items-md-start">
                                <div className={`d-inline-block mb-2 ${styles['action-buttons-wrapper']}`}>
                                    <div className={styles['download-action-button']}>
                                        <div><img src={playstore} className={styles.icon} alt="Play Store" /></div>
                                        <div>
                                            <div className={styles['text-xs']}>Download on the</div>
                                            <div className={styles['text-sm']}>Google Play</div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`d-inline-block ${styles['action-buttons-wrapper']}`}>
                                    <div className={styles['download-action-button']}>
                                        <div><img src={apple} className={styles.icon} alt="Apple Store" /></div>
                                        <div>
                                            <div className={styles['text-xs']}>Download on the</div>
                                            <div className={styles['text-sm']}>Apple Store</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <div className="d-flex align-items-center justify-content-between mt-3 gap-3 gap-lg-0 flex-column flex-lg-row">
                    <div>
                        <div className="fw-medium fs-5 text-center">
                            Connect with Maelano
                        </div>
                        <div className="d-flex gap-3">
                            <img src={facebook} />
                            <img src={instagram} />
                            <img src={linkedin} />
                            <img src={twitter} />
                            <img src={pinterest} />
                        </div>
                    </div>

                    <div className="d-flex gap-2 align-items-center flex-column flex-lg-row">
                        <div className="fw-medium fs-5 text-lg-center">
                            Payment options:
                        </div>
                        <Row className="align-items-center row-gap-3">
                            <Col xs={4} md={2} className="d-flex justify-content-center">
                                <img src={paypal} />
                            </Col>
                            <Col xs={4} md={2} className="d-flex justify-content-center">
                                <img src={visa} />
                            </Col>
                            <Col xs={4} md={2} className="d-flex justify-content-center">
                                <img src={gpay} />
                            </Col>
                            <Col xs={4} md={2} className="d-flex justify-content-center">
                                <img src={express} />
                            </Col>
                            <Col xs={4} md={2} className="d-flex justify-content-center">
                                <img src={master} />
                            </Col>
                            <Col xs={4} md={2} className="d-flex justify-content-center">
                                <img src={applepay} />
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

            <div className={styles["rights-reserved"]}>
                <div className="fw-medium fs-6 fs-md-5 text-center text-md-end">
                    All rights Reserved @2024 - Maelano
                </div>
            </div>
        </footer>
    );
};

export default LoginFooter;